import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { gsap } from "gsap";
import { registerGsapPlugins } from "utils/gsap.js";
import { graphql } from "gatsby";
import { useStaticQuery } from "gatsby";
import { Link } from "gatsby";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
//assets
import logo from "assets/svg/logo.svg";



//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";
import colors from "styles/colors.js";

//components
import MainWrapper from "components/global/MainWrapper.js";
import ContactButtons from "components/global/nav/ContactButtons.js";



const Wrapper = styled.nav`
position: fixed;
margin-top: 2rem;
z-index: 9999;
width: 100%;

  ${MainWrapper}{


    position: relative;
    @media all and (max-width: ${mediaQuery.tablet}){
    background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  border-radius: 0.4rem;
  display: flex;
flex-direction: column;
justify-content: space-between;
height: 5rem;
overflow: hidden;
transition: height 0.4s ease;
${({ $isMenuOpen }) =>
  $isMenuOpen &&
  css`
  height: 44rem;
  `}

}

  }
`;

const NavWrapper = styled.div`
display: inline-flex;
align-items: center;
gap: 3.2rem;
position: relative;
padding: 0.5rem 0 0.5rem 1.6rem;

  @media all and (max-width: ${mediaQuery.tablet}){
  width: 100%;
  padding: 1rem ;
  flex-direction: column;
  align-items: flex-start;
  }

`;

const Background = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  transform: translateX(0);
  transition: width 0.25s ease, transform 0.25s ease, opacity 0.2s ease;

  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  border-radius: 0.4rem;

  @media all and (max-width: ${mediaQuery.tablet}){
    display: none;
  }
`;

const Logo = styled.img`

object-fit: contain;
`;


const Links = styled.ul`
display: flex;

@media all and (max-width: ${mediaQuery.tablet}){
flex-direction: column;
width: 100%;
align-items: center;
margin: 2rem 0;
}
`;

const LinkItem = styled.li`
list-style: none;
padding: 1rem 1.6rem;
`;

const StyledLink = styled(Link)`
  font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize1.lineHeight};
  text-decoration: none;
  @media all and (max-width: ${mediaQuery.tablet}){
    font-size: ${typographySizes.text.tekstSize3.size.desktop}rem;
    line-height: ${typographySizes.text.tekstSize3.lineHeight};
  }
  `;

const StyledScrollLink = styled(ScrollLink)`
  font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize1.lineHeight};
  text-decoration: none;
  cursor: pointer;
  @media all and (max-width: ${mediaQuery.tablet}){
    font-size: ${typographySizes.text.tekstSize3.size.desktop}rem;
    line-height: ${typographySizes.text.tekstSize3.lineHeight};
  }
  `;

const LogoWrapper = styled.div`
display: flex;
justify-content: space-between;
width: 100%;
`;

const HamburgerButton = styled.button`
display: none;
@media all and (max-width: ${mediaQuery.tablet}){
display: flex;
align-items: center;
justify-content: center;
width: 3.2rem;
height: 3.2rem;
background: transparent;
border: none;
padding: 0;
position: relative;
cursor: pointer;
}
`;

const HamburgerLine = styled.span`
position: absolute;
width: 3.2rem;
height: 0.2rem;
background: ${colors.white};
transition: transform 0.25s ease, background 0.2s ease;

  &:first-child {
    transform: ${({ $isOpen }) =>
      $isOpen ? "rotate(45deg)" : "translateY(-0.4rem)"};
  }

  &:last-child {
    transform: ${({ $isOpen }) =>
      $isOpen ? "rotate(-45deg)" : "translateY(0.4rem)"};
  }
`;


const Nav = () => {
 



  const navWrapperRef = useRef(null);
  const backgroundRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);
  const isTabletDown = () => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width: ${mediaQuery.tablet})`).matches;
  };

  const moveBackground = (event) => {
    if (isTabletDown()) return;
    if (!navWrapperRef.current || !backgroundRef.current) return;
    const linkRect = event.currentTarget.getBoundingClientRect();
    const containerRect = navWrapperRef.current.getBoundingClientRect();
    const left = linkRect.left - containerRect.left;

    backgroundRef.current.style.width = `${linkRect.width}px`;
    backgroundRef.current.style.transform = `translateX(${left}px)`;
    backgroundRef.current.style.borderRadius = "100rem";
  };

  const hideBackground = () => {
    if (isTabletDown()) return;
    if (!navWrapperRef.current || !backgroundRef.current) return;
    const containerRect = navWrapperRef.current.getBoundingClientRect();
    backgroundRef.current.style.width = `${containerRect.width}px`;
    backgroundRef.current.style.transform = "translateX(0)";
    backgroundRef.current.style.borderRadius = "0.4rem";
  };

  useLayoutEffect(() => {
    hideBackground();
    const rafId = requestAnimationFrame(hideBackground);

    let observer;
    if (!isTabletDown() && navWrapperRef.current && "ResizeObserver" in window) {
      observer = new ResizeObserver(() => hideBackground());
      observer.observe(navWrapperRef.current);
    }

    return () => {
      cancelAnimationFrame(rafId);
      if (observer) observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => hideBackground();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);





  return (
    <Wrapper $isMenuOpen={isMenuOpen}>
           <MainWrapper>
      <NavWrapper ref={navWrapperRef}>
        <Background ref={backgroundRef} />
        <LogoWrapper>
        <Link to="/">
          <Logo src={logo} alt="Logo" />
        </Link>
        <HamburgerButton
          type="button"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          <HamburgerLine $isOpen={isMenuOpen} />
          <HamburgerLine $isOpen={isMenuOpen} />
        </HamburgerButton>
        </LogoWrapper>
     
  <Links onMouseLeave={hideBackground}>

    <LinkItem onMouseEnter={moveBackground} onClick={closeMenu}>
      <StyledLink to="/portfolio">Portfolio</StyledLink>
    </LinkItem>

    <LinkItem onMouseEnter={moveBackground} onClick={closeMenu}>
      <StyledLink to="/services">Services</StyledLink>
    </LinkItem>
    <LinkItem onMouseEnter={moveBackground} onClick={closeMenu}>
      <StyledLink to="/about">About</StyledLink>
    </LinkItem>



    <LinkItem onMouseEnter={moveBackground} onClick={closeMenu}>
      <StyledScrollLink spy={true} smooth={true} offset={-100} duration={500} to="footer">Contact</StyledScrollLink>
    </LinkItem>
 
  </Links>

  </NavWrapper>
  

<ContactButtons />

      </MainWrapper>
    </Wrapper>
  );
};

export default Nav;
